<div class="deep-dive">
  <!-- Filters — all driven from the same dataset; changing one refreshes graph, cards and table -->
  <div class="filters">
    <div class="filter">
      <label>Marketing Config</label>
      <div class="custom-dropdown">
        <button type="button" class="custom-dropdown-trigger" (click)="toggleDropdown('marketing', $event)">
          <span class="custom-dropdown-value-label">{{ getSelectedValue('marketing') }}</span>
          <span
            *ngIf="hasSelectedValue('marketing')"
            class="custom-dropdown-remove"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Remove ' + getSelectedValue('marketing')"
            (click)="removeSelectedOption('marketing', $event)"
            (keydown.enter)="removeSelectedOption('marketing', $event)"
            (keydown.space)="removeSelectedOption('marketing', $event)">×</span>
          <span class="custom-dropdown-arrow"></span>
        </button>

        <div class="custom-dropdown-panel" *ngIf="isDropdownOpen('marketing')" (click)="$event.stopPropagation()">
          <input
            class="custom-dropdown-search"
            type="text"
            placeholder="Search"
            data-dropdown-search="marketing"
            [value]="dropdownSearchTerms.marketing"
            (input)="setDropdownSearchTerm('marketing', $any($event.target).value)">
          <button
            type="button"
            class="custom-dropdown-option"
            *ngFor="let option of getFilteredOptions('marketing')"
            [class.selected]="isOptionSelected('marketing', option)"
            (click)="selectOption('marketing', option)">
            {{ option }}
          </button>
        </div>
      </div>
    </div>
    <div class="filter">
      <label>Technical Config</label>
      <div class="custom-dropdown">
        <button type="button" class="custom-dropdown-trigger" (click)="toggleDropdown('technical', $event)">
          <span class="custom-dropdown-value-label">{{ getSelectedValue('technical') }}</span>
          <span
            *ngIf="hasSelectedValue('technical')"
            class="custom-dropdown-remove"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Remove ' + getSelectedValue('technical')"
            (click)="removeSelectedOption('technical', $event)"
            (keydown.enter)="removeSelectedOption('technical', $event)"
            (keydown.space)="removeSelectedOption('technical', $event)">×</span>
          <span class="custom-dropdown-arrow"></span>
        </button>

        <div class="custom-dropdown-panel" *ngIf="isDropdownOpen('technical')" (click)="$event.stopPropagation()">
          <input
            class="custom-dropdown-search"
            type="text"
            placeholder="Search"
            data-dropdown-search="technical"
            [value]="dropdownSearchTerms.technical"
            (input)="setDropdownSearchTerm('technical', $any($event.target).value)">
          <button
            type="button"
            class="custom-dropdown-option"
            *ngFor="let option of getFilteredOptions('technical')"
            [class.selected]="isOptionSelected('technical', option)"
            (click)="selectOption('technical', option)">
            {{ option }}
          </button>
        </div>
      </div>
    </div>
    <div class="filter">
      <label>Fuel Rating</label>
      <div class="custom-dropdown">
        <button type="button" class="custom-dropdown-trigger" (click)="toggleDropdown('fuel', $event)">
          <span class="custom-dropdown-value-label">{{ getSelectedValue('fuel') }}</span>
          <span
            *ngIf="hasSelectedValue('fuel')"
            class="custom-dropdown-remove"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Remove ' + getSelectedValue('fuel')"
            (click)="removeSelectedOption('fuel', $event)"
            (keydown.enter)="removeSelectedOption('fuel', $event)"
            (keydown.space)="removeSelectedOption('fuel', $event)">×</span>
          <span class="custom-dropdown-arrow"></span>
        </button>

        <div class="custom-dropdown-panel" *ngIf="isDropdownOpen('fuel')" (click)="$event.stopPropagation()">
          <input
            class="custom-dropdown-search"
            type="text"
            placeholder="Search"
            data-dropdown-search="fuel"
            [value]="dropdownSearchTerms.fuel"
            (input)="setDropdownSearchTerm('fuel', $any($event.target).value)">
          <button
            type="button"
            class="custom-dropdown-option"
            *ngFor="let option of getFilteredOptions('fuel')"
            [class.selected]="isOptionSelected('fuel', option)"
            (click)="selectOption('fuel', option)">
            {{ option }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Graph -->
  <div class="panel">
    <div class="panel-header">Pricing Action History</div>
    <div class="panel-body">
      <div #chart class="chart"></div>
      <div class="empty" *ngIf="!isLoading && filtered.length === 0">
        No pricing actions match the selected filters.
      </div>
    </div>
  </div>

  <!-- History table — one row per graph point -->
  <div class="panel">
    <div class="panel-header table-header">
      <span>Deep Dive</span>
      <button
        type="button"
        class="download-csv-btn"
        aria-label="Download table records as CSV"
        title="Download table records as CSV"
        [disabled]="!canDownloadDeepDive"
        (click)="downloadDeepDiveCsv()">
        <span class="material-icons" aria-hidden="true">cloud_download</span>
      </button>
    </div>
    <div class="panel-body table-wrap">
      <table>
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of historyRows">
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.key">
                <span *ngSwitchCase="'effective_date'">{{ row.effective_date | date: 'M/d/yyyy' }}</span>
                <span *ngSwitchCase="'price'">{{ row.price }}</span>
                <span *ngSwitchDefault>{{ formatCellValue(row[col.key], col.key) }}</span>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="!isLoading && filtered.length === 0">
            <td [attr.colspan]="columns.length" class="empty-cell">No records found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
